import AuthLayout from '../components/auth/AuthLayout'
import RegisterForm from '../components/auth/RegisterForm'
import MetaTags from '../components/common/MetaTags'

export default function RegisterPage() {
  return (
    <AuthLayout>
      <MetaTags
        title="Sign Up | profile.work"
        description="Create your free profile.work account and build your professional online presence."
      />
      <RegisterForm />
    </AuthLayout>
  )
}
